<template>
  <div class="min-h-screen bg-background">
    <AccessibilityProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </AccessibilityProvider>
  </div>
</template>

<script>
import AuthProvider from './components/AuthProvider.vue'
import AppContent from './components/AppContent.vue'
import AccessibilityProvider from './components/AccessibilityProvider.vue'

export default {
  name: 'App',
  components: {
    AuthProvider,
    AppContent,
    AccessibilityProvider
  }
}
</script>